module.exports = __webpack_public_path__ + "img/rifle.semiauto.ca08e3d7.png";